import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'
import { get } from 'lodash'

// Constants
export const constants = {
  GET_SCHEDULE_REPAIR_SCHEDULES: createSagaAction('GET_SCHEDULE_REPAIR_SCHEDULES'),
  SCHEDULE_REPAIR_UPDATE: createSagaAction('SCHEDULE_REPAIR_UPDATE'),
  SCHEDULE_REPAIR_ADD_SCHEDULE: createSagaAction('SCHEDULE_REPAIR_ADD_SCHEDULE'),
  SCHEDULE_REPAIR_DELETE_SCHEDULE: createSagaAction('SCHEDULE_REPAIR_DELETE_SCHEDULE'),

  // attachments
  UPLOAD_SCHEDULE_REPAIR_ATTACHMENT: createSagaAction('UPLOAD_SCHEDULE_REPAIR_ATTACHMENT'),
  FETCH_SCHEDULE_REPAIR_ATTACHMENTS: createSagaAction('FETCH_SCHEDULE_REPAIR_ATTACHMENTS'),
  UPDATE_SCHEDULE_REPAIR_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_SCHEDULE_REPAIR_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_SCHEDULE_REPAIR_ATTACHMENT: createSagaAction('DELETE_SCHEDULE_REPAIR_ATTACHMENT'),

  // notes
  GET_SCHEDULE_REPAIR_NOTE: createSagaAction('GET_SCHEDULE_REPAIR_NOTE'),
  CREATE_SCHEDULE_REPAIR_NOTE: createSagaAction('CREATE_SCHEDULE_REPAIR_NOTE'),
  EDIT_SCHEDULE_REPAIR_NOTE: createSagaAction('EDIT_SCHEDULE_REPAIR_NOTE'),
  DELETE_SCHEDULE_REPAIR_NOTE: createSagaAction('DELETE_SCHEDULE_REPAIR_NOTE')
}

// Action Creators
export const actions = {
  getScheduleRepairSchedules: jobId => ({
    type: constants.GET_SCHEDULE_REPAIR_SCHEDULES.ACTION,
    jobId
  }),

  updateRepairDates: (jobId, scheduleId, content) => ({
    type: constants.SCHEDULE_REPAIR_UPDATE.ACTION,
    jobId,
    scheduleId,
    content
  }),

  addScheduleRepair: jobId => ({
    type: constants.SCHEDULE_REPAIR_ADD_SCHEDULE.ACTION,
    jobId
  }),

  deleteScheduleRepair: (jobId, scheduleId) => ({
    type: constants.SCHEDULE_REPAIR_DELETE_SCHEDULE.ACTION,
    jobId,
    scheduleId
  }),

  // Attachment actions
  uploadScheduleRepairAttachment: (formData, jobId, userId) => ({
    type: constants.UPLOAD_SCHEDULE_REPAIR_ATTACHMENT.ACTION,
    formData,
    jobId,
    userId
  }),

  fetchScheduleRepairAttachments: jobId => ({
    type: constants.FETCH_SCHEDULE_REPAIR_ATTACHMENTS.ACTION,
    jobId
  }),

  updateScheduleRepairAttachmentDescription: (attachmentId, jobId, description, userId) => ({
    type: constants.UPDATE_SCHEDULE_REPAIR_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    jobId,
    description,
    userId
  }),

  deleteScheduleRepairAttachment: ({ attachmentId, jobId }) => ({
    type: constants.DELETE_SCHEDULE_REPAIR_ATTACHMENT.ACTION,
    attachmentId,
    jobId
  }),

  // notes
  getScheduleNote: jobId => ({
    type: constants.GET_SCHEDULE_REPAIR_NOTE.ACTION,
    jobId
  }),
  createScheduleNote: ({ content, jobId }) => ({
    type: constants.CREATE_SCHEDULE_REPAIR_NOTE.ACTION,
    content,
    jobId
  }),
  editScheduleNote: ({ content, noteId, jobId }) => ({
    type: constants.EDIT_SCHEDULE_REPAIR_NOTE.ACTION,
    content,
    noteId,
    jobId
  }),
  deleteScheduleNote: ({ noteId, jobId }) => ({
    type: constants.DELETE_SCHEDULE_REPAIR_NOTE.ACTION,
    noteId,
    jobId
  })
}

// Reducer
const initialState = {
  selectedJobId: null,
  attachments: []
}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_SCHEDULE_REPAIR_SCHEDULES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_SCHEDULE_REPAIR_SCHEDULES.SUCCESS:
      return {
        ...state,
        schedules: action.payload,
        selectedJobId: get(action, 'payload.data.0.job_id', null),
        loading: false
      }
    case constants.GET_SCHEDULE_REPAIR_SCHEDULES.FAILED:
      return {
        error: action.message,
        loading: false
      }
    case constants.SCHEDULE_REPAIR_UPDATE.SUCCESS:
      return {
        ...state
      }

    case constants.SCHEDULE_REPAIR_ADD_SCHEDULE.ACTION:
      return { ...state, error: null, loading: true }
    case constants.SCHEDULE_REPAIR_ADD_SCHEDULE.SUCCESS:
      return {
        ...state,
        loading: false
      }
    case constants.SCHEDULE_REPAIR_ADD_SCHEDULE.FAILED:
      return {
        error: action.message,
        loading: false
      }
    // NOTES
    case constants.GET_SCHEDULE_REPAIR_NOTE.SUCCESS:
      return { ...state, notes: action.payload }

    case constants.CREATE_SCHEDULE_REPAIR_NOTE.ACTION:
      return { ...state }
    case constants.CREATE_SCHEDULE_REPAIR_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_SCHEDULE_REPAIR_NOTE.ACTION:
      return { ...state }
    case constants.EDIT_SCHEDULE_REPAIR_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_SCHEDULE_REPAIR_NOTE.ACTION:
      return { ...state }
    case constants.DELETE_SCHEDULE_REPAIR_NOTE.SUCCESS:
      return {
        ...state
      }
    // ATTACHMENTS
    case constants.UPLOAD_SCHEDULE_REPAIR_ATTACHMENT.ACTION:
      return {
        ...state,
        uploadingAttachment: true
      }
    case constants.UPLOAD_SCHEDULE_REPAIR_ATTACHMENT.SUCCESS:
      return {
        ...state,
        attachments: [...state.attachments, action.payload],
        uploadingAttachment: false
      }
    case constants.UPDATE_SCHEDULE_REPAIR_ATTACHMENT_DESCRIPTION.SUCCESS: {
      const attach = state.attachments.find(f => f.attachment_id === action.attachmentId)
      attach.description = action.description
      return {
        ...state,
        attachments: [...state.attachments]
      }
    }
    case constants.FETCH_SCHEDULE_REPAIR_ATTACHMENTS.ACTION:
      return {
        ...state,
        loadingAttachments: true
      }
    case constants.FETCH_SCHEDULE_REPAIR_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        attachments: action.payload.data,
        loadingAttachments: false
      }
    case constants.DELETE_SCHEDULE_REPAIR_ATTACHMENT.ACTION:
      return {
        ...state,
        deletingAttachment: true
      }
    case constants.DELETE_SCHEDULE_REPAIR_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false,
        attachments: state.attachments.filter(a => a.attachment_id !== action.attachmentId)
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/scheduleRepairActions.js